module.exports = __webpack_public_path__ + "static/media/othergroup_icon.e647721d.svg";